import React from "react";
import { Alert, Empty, Form, Select } from "antd";
import useSWR from "swr";
import get from "lodash/get";
import moment from "moment";

const { Option } = Select;

const specimenType = 'BLDV';

function getUrl(patientId) {
  if (!patientId) return null;

  return `https://servers.techconnect.cl/HAPI/Specimen/?patient=Patient/${patientId}&type=${specimenType}`;
}

export default function SpecimentField({ patientId }) {
  const { data, error } = useSWR(getUrl(patientId));
  const samples = get(data, "entry", []);
  const loading = !data && !error;

  return (
    <Form.Item
      name="specimenId"
      label="Muestra"
      rules={[{ required: true, message: "Tienes que elegir una muestra" }]}
    >
      {patientId ? (
        <Select
          notFoundContent={
            <Empty
              description="Paciente no tiene muestras"
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          }
          loading={loading}
          placeholder="Selecciona una muestra"
          allowClear
        >
          {samples.map(({ resource }) => (
            <Option key={resource.id} value={resource.id}>
              {resource.type.coding[0].display} |{" "}
              {moment(resource.receivedTime).format("lll")}
            </Option>
          ))}
        </Select>
      ) : (
        <Alert showIcon type="info" message="Ingresa un RUN de paciente" />
      )}
    </Form.Item>
  );
}
